module.exports = __webpack_public_path__ + "img/tba.066c815a.png";